/** Content sourced from the existing hanbymagnetpta.givebacks.com site. */

export const CONTACT_EMAIL = 'kyle.kurz@hanbypta.org';
export const VOLUNTEER_EMAIL = 'kyle.kurz@hanbypta.org';

export const SCHOOL_NAME = 'Hanby Elementary';
export const PTA_NAME = 'Hanby PTA';
export const LOCATION = 'Westerville, OH';

export const HERO_IMAGE = `${process.env.PUBLIC_URL}/hero.jpg`;

/** Brand artwork carried over from the old site. */
export const HERO_BANNER = `${process.env.PUBLIC_URL}/images/hanby-banner.jpg`;
export const SCHOOL_DRAWING = `${process.env.PUBLIC_URL}/images/hanby-line-drawing.jpg`;

export const STATS = [
  { label: 'Serving Hanby families since', value: '1923' },
  { label: 'STEAM magnet for grades', value: '1–5' },
  { label: 'All-member meetings per year', value: '9' },
];

export const ABOUT = {
  kicker: 'Welcome to the Hanby PTA',
  title: 'Building a stronger Hanby, together.',
  body:
    'Our mission is to foster a collaborative and supportive environment that enhances the educational experience for every child. Through events, volunteer opportunities, and open communication, we strive to build strong partnerships between home and school.\n\nWe invite you to join us in making this school year truly exceptional — together, we can create a nurturing, dynamic space where our children thrive.',
};

export const SCHOOL_HISTORY = {
  title: 'About Hanby Elementary',
  body:
    "Hanby Elementary opened in 1923 as Westerville High School. Over the years it has served as a high school, middle school, elementary school, and at one point, district administrative offices.\n\nToday, Hanby is home to the district's self-contained gifted program and a STEAM magnet program for grades 1–5, unified from the previous Math/Science and Arts magnets starting in the 2023–2024 school year.",
};

/** Meeting cadence pulled from the existing site's Meetings page. */
export const MEETINGS = {
  cadence:
    'All-Member PTA meetings are held in-person on the third Tuesday of each month, August through April. Board meetings are scheduled as needed and all members are welcome to attend.',
  schedule: [
    { date: 'Sep 2, 2025', label: 'All-Member meeting' },
    { date: 'Oct 7, 2025', label: 'All-Member meeting' },
    { date: 'Jan 6, 2026', label: 'All-Member meeting' },
    { date: 'Mar 3, 2026', label: 'All-Member meeting' },
    { date: 'Apr 7, 2026', label: 'All-Member meeting' },
    { date: 'May 5, 2026', label: 'All-Member meeting' },
  ],
};

/** Upcoming events / recurring programs. */
export const EVENTS = [
  {
    date: '3rd Tues',
    title: 'All-Member PTA Meeting',
    detail:
      'Monthly meeting, August through April. Reports from the board and updates from Principal Caley Nestor Baker. Guest speakers may join to discuss topics relevant to Hanby families.',
    location: 'Hanby Elementary',
  },
  {
    date: 'Year-round',
    title: 'Dine Out with Hanby',
    detail:
      'Monthly restaurant fundraisers. Eat out, support Hanby. Locations and dates posted throughout the school year.',
    location: 'Local restaurants',
  },
];

export const INVOLVEMENT = [
  {
    title: 'Become a member',
    outcome: 'Strength in numbers',
    blurb:
      'Membership is the simplest way to support the PTA. Dues fund classroom grants, family events, and teacher appreciation throughout the year.',
  },
  {
    title: 'Volunteer',
    outcome: 'A little time goes a long way',
    blurb:
      'From event setup to room parents, we have roles for every schedule. Sign up for a single event or stay involved year-round.',
  },
  {
    title: 'Shop with purpose',
    outcome: 'Earn for Hanby while you shop',
    blurb:
      'Sign up for Kroger Community Rewards and download the Box Tops for Education app — Hanby earns every time you check out.',
  },
];

/** 2025–2026 Hanby PTA Executive Board — sourced from the existing site's Leadership page.
 *  Add a per-person photo by setting `image` to a path under public/ (e.g. '/images/board/jane.jpg').
 *  Leave `image` empty ('') to show the default silhouette placeholder. */
export const BOARD = [
  {
    name: 'Jaclyn Fraley',
    role: 'President',
    blurb: 'Leads board meetings and represents the PTA in the school community.',
    image: '',
    alt: '',
  },
  {
    name: 'Rebecca Kurz',
    role: 'Vice President (Fundraising)',
    blurb: 'Supports the president and leads the PTA’s fundraising efforts.',
    image: `${process.env.PUBLIC_URL}/images/board/rebecca-kurz.jpg`,
    alt: 'Rebecca Kurz',
  },
  {
    name: "Kim O'Grady",
    role: 'Treasurer',
    blurb: 'Manages PTA finances, budgeting, and reporting.',
    image: '',
    alt: '',
  },
  {
    name: 'Stacey Yergin',
    role: 'Recording Secretary',
    blurb: 'Keeps meeting minutes and handles internal communication.',
    image: '',
    alt: '',
  },
  {
    name: 'Crystal Ward',
    role: 'Corresponding Secretary',
    blurb: 'Handles external communication and official PTA correspondence.',
    image: '',
    alt: '',
  },
];

/** Additional roles listed on the Leadership page (not on the elected exec board). */
export const LEADERSHIP_OTHER = [
  { role: 'Westerville Parent Council (WPC) Delegate', name: 'Courtney Bowden' },
  { role: 'WPC Alternate', name: 'Emily Quelette' },
  { role: 'School Principal', name: 'Caley Nestor Baker' },
  { role: 'Teacher Liaison', name: 'Sarah Combs and Laurie Preston' },
];

/** Volunteer coordinator roles — many are open and looking for leads. */
export const COORDINATOR_ROLES = [
  { role: 'Back-to-school picnic', lead: 'Jaclyn Fraley' },
  { role: 'Book Fairs', lead: 'Linda Ferguson' },
  { role: 'Dine-to-Donate Fundraising Events', lead: 'Rebecca Kurz' },
  { role: 'Field Trip Coordinator', lead: 'Open!' },
  { role: 'Great Educator Mentor (GEM) Program', lead: 'Open!' },
  { role: 'Hanby Olympics/Field Day', lead: 'Alisa Franklin & Jaclyn Fraley' },
  { role: 'Holiday Shop', lead: 'Open!' },
  { role: 'Who We Are, Near & Far: Family Culture Night', lead: 'Open!' },
  { role: 'Miscellaneous events', lead: 'Open!' },
  { role: 'Plant/Flower Sales', lead: 'Ethan Chesser' },
  { role: 'Reflections Arts Program', lead: 'Open!' },
  { role: 'Scholarships', lead: 'Jaclyn Fraley' },
  { role: 'Spirit Wear', lead: 'Jaclyn Fraley' },
  { role: 'Spring Bazaar', lead: 'Crystal Ward' },
  { role: 'Staff Appreciation Lunches', lead: 'Open!' },
  { role: 'Staff Appreciation Week', lead: 'Open!' },
  { role: 'Volunteer Coordinator', lead: 'Open!' },
];

/** Helpful links — sourced from the existing site's "Helpful school links" sidebar. */
export const RESOURCES = [
  {
    title: 'Hanby Elementary',
    detail: 'School website, staff directory, and announcements.',
    href: 'https://hanby.westerville.k12.oh.us/',
  },
  {
    title: 'Join the PTA',
    detail: 'Become a Hanby PTA member and pay class/PTA fees for the school year.',
    href: 'https://www.zeffy.com/en-US/ticketing/20242025-class-fee-including-pta-membership-2',
  },
  {
    title: 'WCSD Back-to-School',
    detail: 'Back-to-school information and resources from Westerville City Schools.',
    href: 'https://www.westerville.k12.oh.us/teaching-learning/back-to-school-information',
  },
  {
    title: 'Register to volunteer',
    detail: 'Westerville City Schools volunteer registration and forms.',
    href: 'https://www.westerville.k12.oh.us/resources/volunteer',
  },
  {
    title: 'District calendar',
    detail: 'Westerville City Schools calendar and key dates.',
    href: 'https://www.westerville.k12.oh.us/our-district/district-calendar',
  },
  {
    title: 'Guardian Portal',
    detail: 'Grades, attendance, and student information.',
    href: 'https://www.westerville.k12.oh.us/pg-portal',
  },
  {
    title: 'Payschools Central',
    detail: 'School payments and fee management.',
    href: 'https://www.westerville.k12.oh.us/our-district/leadership/fiscal-services/payschools-central',
  },
  {
    title: 'Guardian/SchoolMessenger',
    detail: 'District notifications and messages.',
    href: 'https://go.schoolmessenger.com/#/home',
  },
  {
    title: 'School breakfast menu',
    detail: 'View breakfast menus and food services information.',
    href: 'https://www.westerville.k12.oh.us/operations/food-services',
  },
  {
    title: 'School lunch menu',
    detail: 'View lunch menus and food services information.',
    href: 'https://www.westerville.k12.oh.us/operations/food-services',
  },
  {
    title: 'Manage meal accounts',
    detail: 'Information on managing your student meal account.',
    href: 'https://docs.google.com/document/d/1jylV41kc0_FtqLayK8WidlyYi2DUkCvA3B4FPDHz7K4/mobilebasic',
  },
  {
    title: 'Free lunch program',
    detail: 'Apply for free or reduced-price school meals.',
    href: 'https://www.lunchapplication.com/',
  },
  {
    title: 'WCSD School Board',
    detail: 'Westerville City Schools Board of Education information and meeting agendas.',
    href: 'https://www.westerville.k12.oh.us/our-district/boe',
  },
  {
    title: 'Elementary handbook',
    detail: 'WCSD elementary school handbook and policies (PDF).',
    href: 'https://resources.finalsite.net/images/v1689094209/westervillek12ohus/utlhgk2u1k8uvsnqqohy/ESHandbookupdated06-02-23Final.pdf',
  },
  {
    title: 'Magnet programs',
    detail: "Hanby's STEAM and gifted program details.",
    href: 'https://www.westerville.k12.oh.us/teaching-learning/department-of-elementary-schools/magnet-program',
  },
];

/** Teacher Amazon wish lists — from the existing site's Wish Lists page. */
export const WISH_LISTS = [
  { name: 'Art', href: 'https://www.amazon.com/hz/wishlist/ls/21V7QPMGJV93D?ref_=wl_share' },
  { name: 'Cafeteria', href: 'https://a.co/ifg5rkv' },
  { name: 'PE', href: 'https://www.amazon.com/hz/wishlist/ls/35NT917QMZR7J/ref=hz_ls_biz_ex' },
  { name: 'Recess', href: 'https://www.amazon.com/hz/wishlist/ls/1ANOU271COZ6J/ref=hz_ls_biz_ex' },
  { name: 'Music', href: 'https://www.amazon.com/hz/wishlist/ls/21Z9LAMYHR5AK/ref=hz_ls_biz_ex' },
  { name: 'Clinic', href: 'https://a.co/3VQankk' },
  { name: 'Kratt', href: 'https://a.co/8qfy6KS' },
  { name: '3rd Grade — Katz', href: 'https://www.amazon.com/hz/wishlist/ls/18USAKFGSIOAI/ref=hz_ls_biz_ex' },
  { name: '3rd Grade — Plumb', href: 'https://a.co/d554xVv' },
  { name: '4th Grade — Balaz', href: 'https://a.co/gs9LOJz' },
  { name: '4th Grade — Shroads', href: 'https://a.co/f4U07Vl' },
  { name: '5th Grade — Bilderback', href: 'https://a.co/h7GcXJi' },
  { name: '5th Grade — Sarka', href: 'https://a.co/cJrweQJ' },
];

/** External / social links from the existing site. */
export const MEMBERSHIP_URL =
  'https://www.zeffy.com/en-US/ticketing/20242025-class-fee-including-pta-membership-2';
export const FACEBOOK_URL = 'https://www.facebook.com/groups/863541092068882';
export const WISH_LISTS_HEADING =
  'Our teachers go above and beyond for our students. Contribute to a classroom wish list to directly support their work.';

/** What the PTA sponsors across the year — from the existing site's About page. */
export const SEASONAL_EVENTS = [
  {
    season: 'Fall',
    items: [
      'Back-to-School Social',
      'Curriculum Night',
      'Fall Book Fair',
      'Fall Flower Sale (Mumkins)',
      'Hanby Olympics & Change Challenge',
      'Meet the Teacher',
    ],
  },
  {
    season: 'Winter',
    items: [
      'Family Culture Night',
      'Literature Night',
      'Swim Night',
      'Skate Night',
      'Winter Book Fair',
    ],
  },
  {
    season: 'Spring',
    items: [
      'End-of-Year Picnic',
      'Field Day',
      'Spring Book Fair',
      'Spring Bazaar',
      'Spring Flower Sale',
      '5th-grade Clap-out',
    ],
  },
  {
    season: 'Summer',
    items: ['Summer Playground Meet-Ups'],
  },
  {
    season: 'Year-round',
    items: ['Staff Appreciation Lunches', 'Dine-to-Donate Events'],
  },
];

export const SEASONAL_EVENTS_FOOTNOTE =
  'Plus: field trips, classroom parties, clubs, spirit wear, programming, teacher grants, transportation and more.';

/** Steps to become a Westerville City Schools volunteer — from the existing Volunteer page. */
export const VOLUNTEER_INTRO =
  "Make a meaningful impact by sharing your time and talents — in the classroom, at events, or behind the scenes. To volunteer in the Hanby building or at an off-site Hanby-sponsored event, all adult volunteers must stop into the Hanby office each school year, prior to event day, between 9 a.m.–2 p.m. (please avoid pickup and drop-off times).";

export const VOLUNTEER_STEPS = [
  {
    title: 'Review the Administrative Guidelines',
    detail: "Familiarize yourself with the district's policies for volunteering.",
    href: 'https://go.boarddocs.com/oh/wcsd/Board.nsf/goto?open&id=AX2TGH635997',
    linkLabel: 'Read the guidelines',
  },
  {
    title: 'Complete the Volunteer Training Module',
    detail: 'Access and complete the online training to understand your role and responsibilities.',
    href: 'https://drive.google.com/file/d/1dw-6asz2v3ECuf-kmsUTAU2RAdcN9V0q/view',
    linkLabel: 'Open the training module',
  },
  {
    title: 'Submit a Volunteer Statement Form',
    detail:
      'Level 1 — activities without unsupervised contact with students (classroom helpers, event assistants). Level 2 — activities involving unsupervised contact (chaperones, coaches), which also require a background check. Forms must be signed by the building principal and submitted in person with a valid ID.',
    links: [
      {
        label: 'Level 1 form (PDF)',
        href: 'https://resources.finalsite.net/images/v1711131011/westervillek12ohus/xz3ugqqvo5pq0ebriloy/WCSVolunteerStatementLevel1.pdf',
      },
      {
        label: 'Level 2 form (PDF)',
        href: 'https://resources.finalsite.net/images/v1711130999/westervillek12ohus/egxbwmuyavjnnuug3qhj/WCSVolunteerStatementLevel2.pdf',
      },
      {
        label: 'Level 2 background check',
        href: 'https://securevolunteer.com/WESTERVILLE-CITY-SCHOOLS/?lang=en',
      },
    ],
  },
];

export const VOLUNTEER_NOTE =
  'Volunteer registration must be completed annually and for each school building where you plan to volunteer.';
export const WCSD_VOLUNTEER_URL =
  'https://www.westerville.k12.oh.us/resources/family-resources/volunteer';

/** Long-form school history — from the existing site's History page ("Vine Street School").
 *  Article by Kacy Walko, April 12, 2023. */
export const HISTORY_ARTICLE = {
  title: 'A century on State Street',
  byline: 'By Kacy Walko · April 12, 2023',
  sections: [
    {
      heading: 'Vine Street School: how it all began',
      paragraphs: [
        'In 1920, more than 2,000 people lived in the greater Westerville area.',
        'In 1923, a faculty of 15 was responsible for 607 students in grades 1–12 who attended school together in one building called Vine Street School (now Emerson Elementary). For perspective, the same building houses 206 elementary students in 2023.',
        'Just 25 years earlier, local children received their education in one-room school houses without electricity, indoor plumbing, cafeterias or running water. Though constructed in 1896 and expanded to include four additional rooms in 1908, the facilities at Vine Street School became inadequate for the number of students by 1920.',
        'In 1921, the North Central Association withdrew accreditation from the Westerville schools because of overcrowded conditions at Vine Street School. Voters approved a levy and F. F. Glass of Columbus was hired to design a new building. The community wanted the new school to be a very visible part of the heart of Uptown Westerville. So began construction on a brand new building in 1922.',
      ],
    },
    {
      heading: "Building Westerville's first dedicated high school",
      paragraphs: [
        'In November 1923, Westerville High School (Hanby Elementary today) was dedicated at 56 S. State Street. That fall, more than 300 students in grades 7–12 moved from Vine Street School to the new high school on State Street. The first class to graduate from 56 S. State Street was the Class of 1924.',
        'At a cost of about $165,000, the building was intended to contain ample space for approximately 500 students. A modern building in its time, it contained classrooms, a 700-person auditorium and an area that tripled as a gym, a stage or extra assembly seating.',
        'In 1930, an addition was added to the high school building. Decades later, the building would be reconfigured to remove the former auditorium, among other updates. In 1931, a second primary school (Longfellow) was built to carry half the load of Westerville’s primary school students.',
      ],
    },
    {
      heading: 'Hanby takes namesake as district grows',
      paragraphs: [
        'In May 1960, the building at 56 S. State was renamed Hanby Junior High School, after Benjamin Russell Hanby — an American composer, educator, pastor and abolitionist who lived in Westerville in the mid-1800s and is still known today for his involvement with the Underground Railroad as well as for composing the popular Christmas song "Up on the Housetop," among many others.',
        "That's when Westerville's secondary students left their former seventh- and eighth-grade classmates behind to attend the newest high school at the time on Otterbein Avenue, then named James Russell Lowell High School and now known as Westerville South.",
        'A new junior high building was constructed on Walnut Street in 1965, now known as Walnut Springs Middle School. Blendon Junior High School, now Blendon Middle School, opened in 1969.',
      ],
    },
    {
      heading: 'Hanby through the years',
      paragraphs: [
        'Over the years, Hanby has served as a high school and middle school. It also housed overflow students at one point. From 1990–1991, it held administrative offices.',
        'In 1992, Hanby became an elementary school and has since served traditional, magnet and gifted K–5 students at various times in its more recent history. It has remained operational for the duration of the last century, with the exception of a closure during the 2003–2004 school year, when the district added air conditioning.',
      ],
    },
    {
      heading: 'Hanby today',
      paragraphs: [
        'Today, Hanby is home to the Science, Technology, Engineering, Art & Math (STEAM) Magnet Program for grades 1–5, as well as the district’s self-contained gifted program. Starting with the 2023–2024 school year, the school’s previous Math/Science and Arts magnets unified into a single STEAM focus.',
        'Now led by Principal Caley Nestor Baker, the school is home to more than 354 students and 43 staff members, including 20 full-time teachers.',
      ],
    },
    {
      heading: 'Westerville City School District today',
      paragraphs: [
        'In 2023, the City of Westerville is home to approximately 40,000 people. The Westerville City School District spans 52 square miles in Franklin and Delaware Counties and is the 12th largest district in Ohio.',
        "Today, WCSD's 1,600+ staff members serve upwards of 15,500 students across 16 elementary schools, four (soon to be five) middle schools, three high schools, an Early Learning Center and an Academic Enrichment Center.",
      ],
    },
  ],
};

/** Archival history references — from the History page sidebar. */
export const HISTORY_RESOURCES = [
  { title: 'Hanby timeline video', href: 'https://vimeo.com/822207738/4e56a07876?share=copy' },
  { title: 'Westerville History of Education', href: 'https://westervillelibrary.org/history-of-education/' },
  { title: '1923 WHS dedication', href: 'https://drive.google.com/file/d/10Q8c2xM-zCz5WAcNYuLOfj6qMIdxshST/view?usp=sharing' },
  { title: '1924 Searchlight yearbook', href: 'https://drive.google.com/file/d/1uZsp5VNacWVhCUMCKQXQkPtP3hClpVz4/view?usp=sharing' },
  { title: '1982 Junior H.S. Manual', href: 'https://drive.google.com/file/d/1ZoA9pLe_6_D53MUrJfjIgKHvb4-wBxtC/view?usp=sharing' },
  { title: '1915 Hanby brochure', href: 'https://drive.google.com/file/d/1BEqDOGvZplGWAzmR1qjHOW8Ngl-qVhg2/view?usp=sharing' },
  { title: 'Hanby History by Harold Hancock', href: 'https://drive.google.com/file/d/1c0rV1FJlD522KTxu6jwmrD5Mfj9g2u3s/view?usp=sharing' },
  { title: 'District history', href: 'https://drive.google.com/file/d/1CVTMtbNHzpYP7QJ0ax1MtRZ2WCrJGHbV/view?usp=sharing' },
];

/** Archival photos carried over from the History page (images saved under public/images/history/). */
export const HISTORY_PHOTOS = [
  {
    src: `${process.env.PUBLIC_URL}/images/history/vine-street-classroom-1911.png`,
    caption: 'A Vine Street School classroom in 1911, with teacher Ella King.',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/vine-street-faculty-1923.jpg`,
    caption: 'Vine Street School (now Emerson Elementary) faculty in 1923 (1923 Searchlight).',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/vine-street-students-1923.png`,
    caption: 'Elementary students outside Vine Street School in 1923.',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/hanby-rendering-1923.jpg`,
    caption: 'Architect’s rendering of the new high school (1923 Searchlight).',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/homecoming-court-1940.png`,
    caption: 'Westerville High School Homecoming Court, 1940.',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/auditorium-performance-1940s.jpg`,
    caption: 'Students perform in the auditorium at 56 S. State St. in the late 1940s.',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/shop-class-1948.jpg`,
    caption: 'Students in shop class at 56 S. State St. in the late 1940s.',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/hanby-jr-high-students-1964.jpeg`,
    caption: 'Students at Hanby Junior High School (Hanby Echo, 1964).',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/benjamin-hanby.jpg`,
    caption: 'The school’s namesake, composer and abolitionist Benjamin Russell Hanby.',
  },
  {
    src: `${process.env.PUBLIC_URL}/images/history/hanby-today-2023.jpg`,
    caption: 'Hanby Elementary today (April 2023).',
  },
];

/** Meeting minutes links — from the Meetings page (2025–2026). */
export const MEETING_MINUTES = [
  { date: 'Oct 7, 2025', href: 'https://docs.google.com/document/d/1NptDYpnmW5HWAyLIWKqHfhQeL-4K2Jh7/edit?usp=sharing' },
  { date: 'Jan 6, 2026', href: 'https://docs.google.com/document/d/172-mvqtHsVjwdRFXKZeo1dOm_luApEj8/edit' },
  { date: 'Mar 3, 2026', href: 'https://docs.google.com/document/d/1r4HEj4eeE4UJNglzpLcsJjNh2wsLTuEW/edit' },
];
